import { render, staticRenderFns } from "./LeaverForm.vue?vue&type=template&id=37f59904&scoped=true&"
import script from "./LeaverForm.vue?vue&type=script&lang=js&"
export * from "./LeaverForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f59904",
  null
  
)

export default component.exports